import { Col, Row } from "antd";
import { useBannerMobileContext } from "../../../context/BannerMobileContext/BannerMobileContext";
import FileUploadComponent, { FileData } from "../../../components/FileUploadComponent";
import { FileUploadItem } from "./constants";


const BannerMobileFiles = () => {
	const { bannerMobileDetail, setBannerMobileForm } = useBannerMobileContext();

	const handleFileChange = (files: FileData[] | null, key: string) => {
		if (files && files.length > 0) {
			setBannerMobileForm(prevState => ({
				...prevState,
				[key]: files[0].file
			}));
		}
	};

	return (
		<>
			<Row gutter={20}>
				<Col span={20} key={FileUploadItem.key}>
					<FileUploadComponent
						title={FileUploadItem.label}
						onChange={(fileData: FileData[] | null) => handleFileChange(fileData, FileUploadItem.key)}
						dimensions={FileUploadItem.dimensions}
						fileSize={FileUploadItem.fileSize}
						fileSizeText={FileUploadItem.fileSizeText}
						format={FileUploadItem.format}
						defaultValue={bannerMobileDetail?.imageUrl}
					/>
				</Col>
			</Row>
		</>
	);
};

export default BannerMobileFiles;
